var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "environment-list" },
    [
      _c("el-row", [
        _c(
          "div",
          { staticClass: "button-group" },
          [
            _c(
              "el-button",
              {
                attrs: { size: "small", type: "primary", icon: "el-icon-plus" },
                on: { click: _vm.addEnv }
              },
              [_vm._v(_vm._s(_vm.$t("Add Environment Variables")))]
            ),
            _c(
              "el-button",
              {
                attrs: { size: "small", type: "success" },
                on: { click: _vm.save }
              },
              [_vm._v(_vm._s(_vm.$t("Save")))]
            )
          ],
          1
        )
      ]),
      _c(
        "el-row",
        [
          _c(
            "el-table",
            { attrs: { data: _vm.spiderForm.envs } },
            [
              _c("el-table-column", {
                attrs: { label: _vm.$t("Variable") },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("el-input", {
                          attrs: { placeholder: _vm.$t("Variable") },
                          model: {
                            value: scope.row.name,
                            callback: function($$v) {
                              _vm.$set(scope.row, "name", $$v)
                            },
                            expression: "scope.row.name"
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { label: _vm.$t("Value") },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("el-input", {
                          attrs: { placeholder: _vm.$t("Value") },
                          model: {
                            value: scope.row.value,
                            callback: function($$v) {
                              _vm.$set(scope.row, "value", $$v)
                            },
                            expression: "scope.row.value"
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { label: _vm.$t("Action") },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("el-button", {
                          attrs: {
                            size: "mini",
                            icon: "el-icon-delete",
                            type: "danger"
                          },
                          on: {
                            click: function($event) {
                              return _vm.deleteEnv(scope.$index)
                            }
                          }
                        })
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }